import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'
import { deriveCapabilities, type Capabilities } from '../lib/capabilities'

/**
 * Resolve the signed-in user's available roles from their profile plus
 * any evaluator assignments (so a non-admin who evaluates peers gets the
 * Admin mode too). Degrades to "staff only" when offline / unconfigured.
 */
export function useCapabilities(): Capabilities {
  const { user, profile } = useAuth()

  const { data: evaluatorAssignments = 0 } = useQuery<number>({
    queryKey: ['evaluator-assignments', user?.id],
    queryFn: async () => {
      if (!user) return 0
      const { count } = await supabase
        .from('assignments')
        .select('id', { count: 'exact', head: true })
        .eq('evaluator_id', user.id)
      return count ?? 0
    },
    enabled: !!user,
  })

  return deriveCapabilities(profile, evaluatorAssignments)
}
